import Vue from 'vue'
import { format } from 'date-fns'
// 自定义过滤器
Vue.filter('date-format', function (value, formatStr = 'yyyy-MM-dd HH:mm:ss') {
  if(!value) return ''
  return format(value, formatStr)
})


// WEBPACK FOOTER //
// ./src/utils/filters.js